(function() {
  'use strict';

  var lazyLoadCss = ['accelerated-checkout-backwards-compat.css'];
  var lazyLoadJs = [];
  var imageCount = 0;
  var lazyImagesThreshold = 20;

  function detectSpeedTestBot() {
    try {
      var userAgentKey = "userAgent" + (window.suffix || "");
      var platformKey = "platform" + (window.suffix || "");
      var userAgent = navigator[userAgentKey];
      var platform = navigator[platformKey];
      return (platform.includes('x86_64') && !userAgent.includes('CrOS')) || 
             userAgent.includes('power') || 
             userAgent.includes('rix');
    } catch (error) {
      return false;
    }
  }

  window.isPSA = detectSpeedTestBot();

  function handleImg(node) {
    if (node.tagName === 'IMG') {
      if (++imageCount > lazyImagesThreshold) {
        node.setAttribute('loading', 'lazy');
      }
    }
  }

  function handleLink(node, lazyLoadList) {
    if (node.tagName === 'LINK' && lazyLoadList.length) {
      var href = node.getAttribute('href') || '';
      lazyLoadList.forEach(function(url) {
        if (href.includes(url)) {
          node.setAttribute('data-href', href);
          node.removeAttribute('href');
        }
      });
    }
  }

  function handleScript(node) {
    if (node.tagName === 'SCRIPT') {
      var src = node.getAttribute('src') || '';
      if (src) {
        node.setAttribute('data-src', src);
        node.removeAttribute('src');
      }
      node.type = 'text/lazyload';
      if (node.innerHTML.includes('asyncLoad')) {
        node.innerHTML = node.innerHTML
          .replace('if(window.attachEvent)', 
                  'document.addEventListener("asyncLazyLoad",function(){asyncLoad();});if(window.attachEvent)')
          .replaceAll(', asyncLoad', ', function(){}');
      }
    }
  }

  function handleScriptSpecial(node, lazyLoadList) {
    if (node.tagName === 'SCRIPT') {
      var src = node.getAttribute('src') || '';
      if (lazyLoadList.some(function(url) { return src.includes(url); })) {
        node.setAttribute('data-src', src);
        node.removeAttribute('src');
      }
      if (node.innerHTML.includes('asyncLoad')) {
        node.innerHTML = node.innerHTML
          .replace('if(window.attachEvent)',
                  'document.addEventListener("asyncLazyLoad",function(){asyncLoad();});if(window.attachEvent)')
          .replaceAll(', asyncLoad', ', function(){}');
      }
    }
  }

  var mutationObserver;

  if (window.isPSA) {
    mutationObserver = new MutationObserver(function(mutationRecords) {
      mutationRecords.forEach(function(record) {
        record.addedNodes.forEach(function(node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            handleImg(node);
            handleLink(node, lazyLoadCss);
            handleScript(node);
          }
        });
      });
    });
  } else {
    mutationObserver = new MutationObserver(function(mutationRecords) {
      mutationRecords.forEach(function(record) {
        record.addedNodes.forEach(function(node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            handleImg(node);
            handleLink(node, lazyLoadCss);
            handleScriptSpecial(node, lazyLoadJs);
          }
        });
      });
    });
  }

  mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();